import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Horse_show_entry } from '../../models/horse_show_entry';
import { Signature } from '../../models/signature';
import { SignatureService } from '../../providers/signature.service';
import { PersonService } from '../../providers/person.service';
import { WaiverService } from '../../providers/waiver.service';
import { Person } from '../../models/person';

import { ModalChoosePersonComponent } from '../people/modal-choose-person/modal-choose-person.component';
import { ModalAddPersonComponent } from '../people/modal-add-person/modal-add-person.component';

import { faSave, faPen, faEdit, faPlus, faTrash, faSpinner, faUser, faExchange } from '@fortawesome/fontawesome-pro-regular';

import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import {AccountEntryView} from '../../models/account_entry_view';
import {PendingHorseShowEntryService} from '../../providers/pending-horse-show-entry.service';


@Component({
  standalone: false,
  selector: 'app-modal-edit-signatures-on-entry',
  templateUrl: './modal-edit-signatures-on-entry.component.html',
styleUrls:  ['./modal-edit-signatures-on-entry.component.css']
})
export class ModalEditSignaturesOnEntryComponent extends SmsAbstractAppPage implements OnInit {
	loading: boolean;
	horse_show_name: string = '';
	waiver_text: string = '';
	horse_show_entry: Horse_show_entry = new Horse_show_entry({});
	signature_list: Signature[] = [];
  message_list: string[] = [];

	faSave = faSave;
	faPen = faPen;
	faEdit = faEdit;
	faPlus = faPlus;
	faTrash = faTrash;
	faSpinner = faSpinner;
  faUser = faUser;
  faExchange = faExchange;

  constructor(public activeModal: NgbActiveModal,
    private modal: NgbModal,
    private pendingHorseShowEntryService: PendingHorseShowEntryService,
  	private signatureService: SignatureService,
  	private personService: PersonService,
  	private waiverService: WaiverService) {
  		super();
  	}

  ngOnInit() {
  	this.loading = true;
  }

  setHorse_show_entry(entryView: AccountEntryView){

    this.pendingHorseShowEntryService.get(entryView.entryId).then(horseShowEntry => {

      this.horse_show_entry = horseShowEntry;

      this.signatureService.getSignaturesForEntry(horseShowEntry.id, true).then(signature_list => {
        this.signature_list = signature_list;

        this.message_list = new Array<string>(signature_list.length);

        this.waiverService.getForHorseShow(horseShowEntry.horse_show_id).then(waiver => {
          this.waiver_text = waiver.waiver_text;
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          this.handleError(error);
        });

      }).catch(error => {
        this.loading = false;
        this.handleError(error);
      });

    }).catch(error => {
      this.handleError(error);
    });

  }

  handleSaveChanges(signature: Signature, index: number){

    if(signature.id == undefined || signature.id == ''){
      this.signatureService.create(signature).then(new_signature => {
        this.message_list[index] = "Signature created.";
        signature = new_signature;
      }).catch(error => {
        this.handleError(error);
      });
    } else {
        this.signatureService.update_signature(signature).then(upd_signature => {
        this.message_list[index] = "Signature saved.";
      }).catch(error => {
        this.handleError(error);
      });
    }


  }

  handleAddSignature(role: string){
  	let signature: Signature = new Signature({
         document_type: "HORSE SHOW ENTRY",
         document_id: this.horse_show_entry.id,
         read_document: false,
         signature: '',
         user_id: this.horse_show_entry.user_id,
         user_person_id: '',
         role: role,
         party_to_entry: role,
         accepted_terms: false,
         person: new Person({}),
         responsible_party: false,
            contact_consent: false
          });

    this.signature_list.push(signature);
    this.message_list.push("Add a person to this signature to unlock signature field.");

  }

   handleChoosePerson(signature: Signature) {
    let modal_ref_person = this.modal.open(ModalChoosePersonComponent, { size: 'lg'});

      modal_ref_person.componentInstance.person_selected$.subscribe((selected_person: Person) => {
       modal_ref_person.close();
         signature.person = selected_person;
         signature.user_person_id = selected_person.id;
       });
  }

  handleAddPerson(signature: Signature) {

      let modal_ref_person = this.modal.open(ModalAddPersonComponent, { size: 'lg'});

      modal_ref_person.componentInstance.person = new Person({});

      modal_ref_person.componentInstance.person_saved$.subscribe((new_person: Person) => {
        modal_ref_person.close();

        //save the peep
        this.personService.create(new_person).then(new_person => {
          signature.person = new_person;
          signature.user_person_id = new_person.id;
        }).catch(error => {
          this.handleError(error);
        });


       }, error => {
         this.handleError(error);
       });

  }


}
